import { ArrowDownIcon, ArrowUpIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";
import { TemplatesType } from "@rjsf/utils";
import { AllHTMLAttributes } from "react";

import { AddIcon, TrashIcon } from "@nens/ranalib";

export const ButtonTemplates: TemplatesType["ButtonTemplates"] = {
  AddButton: (props: AllHTMLAttributes<HTMLButtonElement>) => (
    <IconButton
      isDisabled={props.disabled}
      variant="accent"
      onClick={props.onClick}
      icon={<AddIcon />}
      aria-label={""}
    />
  ),
  SubmitButton: () => undefined,
  CopyButton: (props: AllHTMLAttributes<HTMLButtonElement>) => (
    <IconButton
      isDisabled={props.disabled}
      variant="accent"
      onClick={props.onClick}
      icon={<AddIcon />}
      aria-label={""}
    />
  ),
  MoveDownButton: (props: AllHTMLAttributes<HTMLButtonElement>) => (
    <IconButton
      isDisabled={props.disabled}
      variant="accent"
      onClick={props.onClick}
      icon={<ArrowDownIcon />}
      aria-label={""}
    />
  ),
  MoveUpButton: (props: AllHTMLAttributes<HTMLButtonElement>) => (
    <IconButton
      isDisabled={props.disabled}
      variant="accent"
      onClick={props.onClick}
      icon={<ArrowUpIcon />}
      aria-label={""}
    />
  ),
  RemoveButton: (props: AllHTMLAttributes<HTMLButtonElement>) => (
    <IconButton
      isDisabled={props.disabled}
      w="button"
      variant="accent"
      onClick={props.onClick}
      aria-label={""}
      icon={<TrashIcon />}
    />
  ),
};
